import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { selectedPartnershipSelector } from '../../modules/selectors/partnerships'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'
import {
  dv360ListItemInsights,
  facebookListItemInsights,
  googleListItemInsights,
  tikTokListItemInsights
} from '../../constants/other'

export const useGetListItemInsights = platform => {
  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { advanced_metrics: advancedMetrics } = selectedPartnership

  const platformInsights = useMemo(() => {
    if (platform === FACEBOOK_PLATFORM) {
      return facebookListItemInsights
    } else if (platform === GOOGLE_PLATFORM) {
      return googleListItemInsights
    } else if (platform === DV_360_PLATFORM) {
      return dv360ListItemInsights
    } else if (platform === TIKTOK_PLATFORM) {
      return tikTokListItemInsights
    }
  }, [platform])

  return useMemo(() => {
    return [
      ...platformInsights, //
      ...(advancedMetrics ? ['cpa'] : [])
    ]
  }, [advancedMetrics, platformInsights])
}
